<template>
  <div id="feedbackform">
    <div class="sixteentosix omt-6 omt-md-25">
      <div
        class="kachelimage header-image"
        style="background: url('/static/img/default_header.png')"
      >
        <div class="headline">
          <div class="text-subtitle-2 text-md-h5">{{ $t("feedBackForm") }}</div>
        </div>
      </div>
    </div>
    
    <div class="pt-16">
      <div class="mx-0 row disablerow align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 innercreatetraining pl-8 pr-8">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div>
                <!-- First section -->
                <h5 style="margin-bottom:20px;">{{ $t("informationSection") }}</h5>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3 pt-2"
                      dense
                      outlined
                      :label="$t('nameOftheTraining')"
                      v-model="request.trainingName"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3 feedback-trainer-lebel"
                      dense
                      outlined
                      :label="$t('trainersName')"
                      v-model="request.trainerName"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                   <v-col cols="6">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('training_event_category')"
                      v-model="request.trainingCategoryName"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                 
                  <v-col cols="6"  v-show="request.trainingDate">
                    
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('periodOfTraining')"
                      v-model="request.trainingDate"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" v-show="request.trainingDate_TH_1">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('periodOfTraining_th_1')"
                      v-model="request.trainingDate_TH_1"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                      <v-col cols="6" v-show="request.trainingDate_TH_2">
                    
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('periodOfTraining_th_2')"
                      v-model="request.trainingDate_TH_2"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" v-show="request.trainingDate_TH_3">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('periodOfTraining_th_3')"
                      v-model="request.trainingDate_TH_3"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6"  v-show="request.trainingDate_PR_1">
                    
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('periodOfTraining_pr_1')"
                      v-model="request.trainingDate_PR_1"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  
                  <v-col cols="6"  v-show="request.trainingDate_PR_2">  
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('periodOfTraining_pr_2')"
                      v-model="request.trainingDate_PR_2"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                       <v-col cols="6" v-show="request.trainingDate_PR_3">
                    
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('periodOfTraining_pr_3')"
                      v-model="request.trainingDate_PR_3"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>

                       
                  <v-col cols="6" v-show="request.trainingLocation">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('trainingLocation')"
                      v-model="request.trainingLocation"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" v-show="request.trainingLocation_TH_1">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('trainingLocation_th_1')"
                      v-model="request.trainingLocation_TH_1"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" v-show="request.trainingLocation_TH_2">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('trainingLocation_th_2')"
                      v-model="request.trainingLocation_TH_2"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                      
                  <v-col cols="6" v-show="request.trainingLocation_TH_3">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('trainingLocation_th_3')"
                      v-model="request.trainingLocation_TH_3"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" v-show="request.trainingLocation_PR_1">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('trainingLocation_pr_1')"
                      v-model="request.trainingLocation_PR_1"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" v-show="request.trainingLocation_PR_2">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('trainingLocation_pr_2')"
                      v-model="request.trainingLocation_PR_2"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" v-show="request.trainingLocation_PR_3">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-3"
                      dense
                      outlined
                      :label="$t('trainingLocation_pr_3')"
                      v-model="request.trainingLocation_PR_3"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                 
                </v-row>
              </div>
              <div>
                <p class="font-weight-bold">{{ $t("pleaseRate") }}</p>
                <p>{{ $t("rateOptions") }}</p>
                <!-- Second section -->
                <div class="tbl_scroller">
                  <table class="border border-dark table table-bordered">
                    <thead>
                      <tr>
                        <th class="invitation-column">
                          {{ $t("preparationSection") }}
                        </th>
                        <th class="text-center">1</th>
                        <th class="text-center">2</th>
                        <th class="text-center">3</th>
                        <th class="text-center">4</th>
                        <th class="text-center">5</th>
                        <th class="text-center">6</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("receivedInvitation") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.receivedInvitation"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.receivedInvitation"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.receivedInvitation"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.receivedInvitation"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.receivedInvitation"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.receivedInvitation"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("satisfiedPreparation") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.satisfiedPreparation"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.satisfiedPreparation"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.satisfiedPreparation"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.satisfiedPreparation"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.satisfiedPreparation"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.satisfiedPreparation"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                <!-- Third section -->
                <div class="tbl_scroller">
                  <table class="border border-dark table table-bordered">
                    <thead>
                      <tr>
                        <th class="invitation-column">
                          {{ $t("trainingRoom") }}
                        </th>
                        <th class="text-center">1</th>
                        <th class="text-center">2</th>
                        <th class="text-center">3</th>
                        <th class="text-center">4</th>
                        <th class="text-center">5</th>
                        <th class="text-center">6</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("suitableTrainingRoom") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.suitableTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.suitableTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.suitableTrainingRoom"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.suitableTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.suitableTrainingRoom"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.suitableTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("expectedTrainingRoom") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.expectedTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.expectedTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.expectedTrainingRoom"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.expectedTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.expectedTrainingRoom"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.expectedTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("breakTimes") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.breakTimes">
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.breakTimes">
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.breakTimes">
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.breakTimes">
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.breakTimes">
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.breakTimes">
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("cleanTrainingRoom") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.cleanTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.cleanTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.cleanTrainingRoom"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.cleanTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.cleanTrainingRoom"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.cleanTrainingRoom"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                <!-- Fourth section -->
                <div class="tbl_scroller">
                  <table class="border border-dark table table-bordered">
                    <thead>
                      <tr>
                        <th class="invitation-column">
                          {{ $t("trainingStructure") }}
                        </th>
                        <th class="text-center">1</th>
                        <th class="text-center">2</th>
                        <th class="text-center">3</th>
                        <th class="text-center">4</th>
                        <th class="text-center">5</th>
                        <th class="text-center">6</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("easyTrainingMaterial") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.easyTrainingMaterial"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.easyTrainingMaterial"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.easyTrainingMaterial"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.easyTrainingMaterial"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.easyTrainingMaterial"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.easyTrainingMaterial"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>

                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("theorypractice") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.theorypractice"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.theorypractice"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.theorypractice"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.theorypractice"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.theorypractice"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.theorypractice"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>

                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("supportedlearningprocess") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.supportedlearningprocess"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.supportedlearningprocess"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.supportedlearningprocess"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.supportedlearningprocess"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.supportedlearningprocess"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.supportedlearningprocess"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-col>

            <v-col cols="12" class="pt-0">
              <div>
                <!-- Fifth section -->
                <div class="tbl_scroller">
                  <table class="border border-dark table table-bordered">
                    <thead>
                      <tr>
                        <th class="invitation-column">
                          {{ $t("trainingImplementation") }}
                        </th>
                        <th class="text-center">1</th>
                        <th class="text-center">2</th>
                        <th class="text-center">3</th>
                        <th class="text-center">4</th>
                        <th class="text-center">5</th>
                        <th class="text-center">6</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("learningspeed") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.learningspeed"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.learningspeed"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.learningspeed"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.learningspeed"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.learningspeed"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.learningspeed"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>

                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("involvedtraining") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.involvedtraining"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.involvedtraining"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.involvedtraining"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.involvedtraining"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.involvedtraining"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.involvedtraining"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>

                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("newthings") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.newthings">
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.newthings">
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.newthings">
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.newthings">
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.newthings">
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group class="text-center" v-model="request.newthings">
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <!-- Sixth section -->
                  <div class="tbl_scroller">
                    <table class="border border-dark table table-bordered">
                      <thead>
                        <tr>
                          <th class="invitation-column">
                            {{ $t("trainerSection") }}
                          </th>
                          <th class="text-center">1</th>
                          <th class="text-center">2</th>
                          <th class="text-center">3</th>
                          <th class="text-center">4</th>
                          <th class="text-center">5</th>
                          <th class="text-center">6</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="invitation-column">
                            <p>{{ $t("trainerwellprepared") }}</p>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerwellprepared"
                            >
                              <v-radio class="feedback-radio" value="Excellent"></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerwellprepared"
                            >
                              <v-radio class="feedback-radio" value="Good"></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerwellprepared"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Satisfactory"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerwellprepared"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Sufficient"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerwellprepared"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Insufficient"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerwellprepared"
                            >
                              <v-radio class="feedback-radio" value="Deficient"></v-radio>
                            </v-radio-group>
                          </td>
                        </tr>

                        <tr>
                          <td class="invitation-column">
                            <p>{{ $t("trainerprofessional") }}</p>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerprofessional"
                            >
                              <v-radio class="feedback-radio" value="Excellent"></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerprofessional"
                            >
                              <v-radio class="feedback-radio" value="Good"></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerprofessional"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Satisfactory"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerprofessional"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Sufficient"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerprofessional"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Insufficient"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerprofessional"
                            >
                              <v-radio class="feedback-radio" value="Deficient"></v-radio>
                            </v-radio-group>
                          </td>
                        </tr>

                        <tr>
                          <td class="invitation-column">
                            <p>{{ $t("trainerexplained") }}</p>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerexplained"
                            >
                              <v-radio class="feedback-radio" value="Excellent"></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerexplained"
                            >
                              <v-radio class="feedback-radio" value="Good"></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerexplained"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Satisfactory"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerexplained"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Sufficient"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerexplained"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Insufficient"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerexplained"
                            >
                              <v-radio class="feedback-radio" value="Deficient"></v-radio>
                            </v-radio-group>
                          </td>
                        </tr>

                        <tr>
                          <td class="invitation-column">
                            <p>{{ $t("trainerorganized") }}</p>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerorganized"
                            >
                              <v-radio class="feedback-radio" value="Excellent"></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerorganized"
                            >
                              <v-radio class="feedback-radio" value="Good"></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerorganized"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Satisfactory"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerorganized"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Sufficient"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerorganized"
                            >
                              <v-radio
                                class="feedback-radio"
                                value="Insufficient"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-center">
                            <v-radio-group
                              class="text-center"
                              v-model="request.trainerorganized"
                            >
                              <v-radio class="feedback-radio" value="Deficient"></v-radio>
                            </v-radio-group>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div>
                <!-- Seventh section -->
                <div class="tbl_scroller">
                  <table class="border border-dark table table-bordered">
                    <thead>
                      <tr>
                        <th class="invitation-column">
                          {{ $t("conclusion") }}
                        </th>
                        <th class="text-center">1</th>
                        <th class="text-center">2</th>
                        <th class="text-center">3</th>
                        <th class="text-center">4</th>
                        <th class="text-center">5</th>
                        <th class="text-center">6</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("benefitseveryday") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.benefitseveryday"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.benefitseveryday"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.benefitseveryday"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.benefitseveryday"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.benefitseveryday"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.benefitseveryday"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>

                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("recommendKnorr") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendKnorr"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendKnorr"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendKnorr"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendKnorr"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendKnorr"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendKnorr"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>

                      <tr>
                        <td class="invitation-column">
                          <p>{{ $t("recommendtraining") }}</p>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendtraining"
                          >
                            <v-radio class="feedback-radio" value="Excellent"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendtraining"
                          >
                            <v-radio class="feedback-radio" value="Good"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendtraining"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Satisfactory"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendtraining"
                          >
                            <v-radio class="feedback-radio" value="Sufficient"></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendtraining"
                          >
                            <v-radio
                              class="feedback-radio"
                              value="Insufficient"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-center">
                          <v-radio-group
                            class="text-center"
                            v-model="request.recommendtraining"
                          >
                            <v-radio class="feedback-radio" value="Deficient"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
   <v-dialog v-model="openDeleteDialog" width="500">
        <h4>{{ $t("confirm_delete_feedback") }}</h4>
        <v-card-actions
          class="align_center"
        >
          
          <v-btn
            @click="openDeleteDialog = false"
            outlined
            depressed
            tile
            class="cancelBtn mr-2 mb-2"
          >
            {{ $t("cancel") }}</v-btn
          >
          <v-btn
            @click="deleteFeedBack()"
            v-show="$rights.includes('DELETE_FEEDBACK')"
            outlined
            depressed
            tile
            class="savebutton mb-2"
          >
           <img src="/static/img/popup-delete-icon.svg" class="popup-delete-icon"> {{ $t("delete") }}</v-btn
          >
        </v-card-actions>
      </v-dialog>
        <!-- Right Area -->
        <div class="col-xl-3 ml-1 px-0 pl-8 pl-8 pl-md-12 pl-lg-8 row pt-0 onlyContact">
          <div class="col-xl-12 right-side-block">
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              v-if="
               (!$rights.includes('CREATE_TRAINING_EVENT') && !$rights.includes('VIEW_BOOKINGS')) ||
                (addmanual === 'true' && ( $rights.includes('CREATE_TRAINING_EVENT') || $user.trainer) )
             "
              @click="submitfeedback()"
              >{{ $t("saveFeedBack") }}</v-btn
            >
            <v-btn
              outlined
              depressed
              tile
              class="backbutton cancelbutton mr-2 mb-2"
              @click="$routerBack()"
              >{{ $t("back") }}</v-btn
            >
            <v-btn
              @click="$routerBack()"
              outlined
              depressed
              tile
              class="cancelBtn mr-2 mb-2"
              >{{ $t("cancelFeedBack") }}</v-btn
            >
            <v-btn
               v-show="feedBackId && $rights.includes('DELETE_FEEDBACK')"
              @click="openDeleteDialog = true"
              outlined
              depressed
              tile
              class="deletebutton cancelBtn mr-2 mb-2"
              ><v-icon color="#444">mdi-delete</v-icon>
              {{ $t("delete") }}</v-btn
            >
          </div>
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type:null,
      feedBackId:null,
      openDeleteDialog: false,
      addmanual: null,
      request: {
        bookingId: null,
        trainingEventId: null,
        trainingName: null,
        trainerName: null,
        trainingCategoryName : null,
        trainingDate: '',
        trainingLocation: '',
        receivedInvitation: null,
        satisfiedPreparation: null,
        suitableTrainingRoom: null,
        expectedTrainingRoom: null,
        breakTimes: null,
        cleanTrainingRoom: null,
        easyTrainingMaterial: null,
        theorypractice: null,
        supportedlearningprocess: null,
        learningspeed: null,
        involvedtraining: null,
        newthings: null,
        trainerwellprepared: null,
        trainerprofessional: null,
        trainerexplained: null,
        trainerorganized: null,
        benefitseveryday: null,
        recommendKnorr: null,
        recommendtraining: null,
      },
    };
  },

  mounted() {
    this.addmanual = this.$route.query.addmanual;
    this.request.bookingId = this.$route.query.bookingId;
    this.request.trainingEventId = this.$route.query.trainingEventId;
    this.fetchEditingTrainingEvent();
    if (this.request.bookingId && this.request.trainingEventId) {
      this.fetchOnlineFeedBackForm();
    } else if (this.request.trainingEventId && this.addmanual === "true") {
      this.fetchManualFeedBackForm();
    } else if (this.$route.query.feedbackId != null) {
      this.viewFeedBackForm();
    }
  },

  methods: {
     deleteFeedBack() {
     

      var _this = this;

      this.$axios
        .delete("/api/training/event/" + parseInt(_this.feedBackId, 10)+"/feedbacks/"+parseInt(this.request.trainingEventId,10)+"/"+_this.type)
        .then(function (response) {
          _this.$noty.success(
            _this.$t("feedback_deleted")
          );
          _this.$routerBack();
        })
        .catch(this.onError);
    },
    fetchEditingTrainingEvent() {
      var _this = this;
      this.$axios
        .get("/api/training/event/" + this.request.trainingEventId)
        .then(function (response) {
          _this.request.trainerName = response.data.trainers;
          _this.request.trainingName =
           response.data.training != null ? response.data.training.designationsMap[_this.$locale] : '';
          _this.request.trainingCategoryName =
           response.data.trainingEventCategory ? response.data.trainingEventCategory.designationsMap[_this.$locale] :'';        
           if(response.data.startDateFormatted) {
           _this.request.trainingDate = response.data.startDateFormatted;
             _this.request.trainingLocation = response.data.locationFormatted ? response.data.locationFormatted : _this.$t('virtual');
           }
           if(response.data.startDateFormatted_PR_1) {
           _this.request.trainingDate_PR_1 = response.data.startDateFormatted_PR_1;
             _this.request.trainingLocation_PR_1 = response.data.locationFormatted_PR_1 ? response.data.locationFormatted_PR_1 : _this.$t('virtual');
           }
           if(response.data.startDateFormatted_PR_2) {
           _this.request.trainingDate_PR_2 = response.data.startDateFormatted_PR_2;
             _this.request.trainingLocation_PR_2 = response.data.locationFormatted_PR_2 ? response.data.locationFormatted_PR_2 : _this.$t('virtual');
           }
           if(response.data.startDateFormatted_PR_3) {
           _this.request.trainingDate_PR_3 = response.data.startDateFormatted_PR_3;
             _this.request.trainingLocation_PR_3 = response.data.locationFormatted_PR_3 ? response.data.locationFormatted_PR_3 : _this.$t('virtual');

           }
           if(response.data.startDateFormatted_TH_1) {
            _this.request.trainingDate_TH_1 = response.data.startDateFormatted_TH_1;
              _this.request.trainingLocation_TH_1 = response.data.locationFormatted_TH_1 ? response.data.locationFormatted_TH_1 : _this.$t('virtual');

           }
           if(response.data.startDateFormatted_TH_2) {
            _this.request.trainingDate_TH_2 = response.data.startDateFormatted_TH_2;
              _this.request.trainingLocation_TH_2 = response.data.locationFormatted_TH_2 ? response.data.locationFormatted_TH_2 : _this.$t('virtual');

           }
           if(response.data.startDateFormatted_TH_3) {
            _this.request.trainingDate_TH_3 += response.data.startDateFormatted_TH_3;
             _this.request.trainingLocation_TH_3 = response.data.locationFormatted_TH_3 ? response.data.locationFormatted_TH_3 : _this.$t('virtual');
           }

        
       
        })
        .catch(this.onError);
    },

    fetchOnlineFeedBackForm() {
      var _this = this;
      this.$axios
        .get("/api/booking/feedback/" + parseInt(this.request.bookingId, 10))
        .then(function (response) {
          if (response.data!==null && response.data.feedback != null) {
            _this.feedBackId=response.data.feedback.id;
            _this.request.receivedInvitation = response.data.feedback.receivedInvitation;
            _this.request.satisfiedPreparation =
              response.data.feedback.satisfiedPreparation;
            _this.request.suitableTrainingRoom =
              response.data.feedback.suitableTrainingRoom;
            _this.request.expectedTrainingRoom =
              response.data.feedback.expectedTrainingRoom;
            _this.request.breakTimes = response.data.feedback.breakTimes;
            _this.request.cleanTrainingRoom = response.data.feedback.cleanTrainingRoom;
            _this.request.easyTrainingMaterial =
              response.data.feedback.easyTrainingMaterial;
            _this.request.theorypractice = response.data.feedback.theorypractice;
            _this.request.supportedlearningprocess =
              response.data.feedback.supportedlearningprocess;
            _this.request.learningspeed = response.data.feedback.learningspeed;
            _this.request.involvedtraining = response.data.feedback.involvedtraining;
            _this.request.newthings = response.data.feedback.newthings;
            _this.request.trainerwellprepared =
              response.data.feedback.trainerwellprepared;
            _this.request.trainerprofessional =
              response.data.feedback.trainerprofessional;
            _this.request.trainerexplained = response.data.feedback.trainerexplained;
            _this.request.trainerorganized = response.data.feedback.trainerorganized;
            _this.request.benefitseveryday = response.data.feedback.benefitseveryday;
            _this.request.recommendKnorr = response.data.feedback.recommendKnorr;
            _this.request.recommendtraining = response.data.feedback.recommendtraining;
          }
        })
        .catch(this.onError);
    },

    fetchManualFeedBackForm() {
      var _this = this;
      this.$axios
        .get(
          "/api/training/event/feedback/" +
            parseInt(this.$route.query.trainingEventId, 10) +
            "/" +
            parseInt(this.$route.query.feedbackId, 10)
        )
        .then(function (response) {
          if (response.data !== null) {
            _this.feedBackId=response.data.id;
            _this.type="manual";
            _this.request.receivedInvitation = response.data.receivedInvitation;
            _this.request.satisfiedPreparation = response.data.satisfiedPreparation;
            _this.request.suitableTrainingRoom = response.data.suitableTrainingRoom;
            _this.request.expectedTrainingRoom = response.data.expectedTrainingRoom;
            _this.request.breakTimes = response.data.breakTimes;
            _this.request.cleanTrainingRoom = response.data.cleanTrainingRoom;
            _this.request.easyTrainingMaterial = response.data.easyTrainingMaterial;
            _this.request.theorypractice = response.data.theorypractice;
            _this.request.supportedlearningprocess =
              response.data.supportedlearningprocess;
            _this.request.learningspeed = response.data.learningspeed;
            _this.request.involvedtraining = response.data.involvedtraining;
            _this.request.newthings = response.data.newthings;
            _this.request.trainerwellprepared = response.data.trainerwellprepared;
            _this.request.trainerprofessional = response.data.trainerprofessional;
            _this.request.trainerexplained = response.data.trainerexplained;
            _this.request.trainerorganized = response.data.trainerorganized;
            _this.request.benefitseveryday = response.data.benefitseveryday;
            _this.request.recommendKnorr = response.data.recommendKnorr;
            _this.request.recommendtraining = response.data.recommendtraining;
          }
        });
    },
    submitfeedback() {
      let _this = this;
      if (this.request.bookingId) {
        this.request.bookingId = parseInt(this.request.bookingId, 10);
        this.$axios
          .post("/api/booking/feedback", this.request)
          .then(function (response) {
            _this.$noty.success(_this.$t("feedback_submitted"));
             _this.$router.push("/categories");
          })
          .catch(this.onError)
          .finally(() => {});
      } else {
        if (this.$route.query.feedbackId) {
          this.request.id = parseInt(this.$route.query.feedbackId, 10);
        }
        this.$axios
          .put("/api/training/event/manualfeedback", this.request)
          .then(function (response) {
            _this.$noty.success(_this.$t("feedback_submitted"));
            // _this.$router.push("/categories");
            _this.$routerBack();
          })
          .catch(this.onError)
          .finally(() => {});
      }
    },
    viewFeedBackForm() {
      var _this = this;
      this.$axios
        .get(
          "/api/booking/feedback/" +
            parseInt(this.$route.query.trainingEventId, 10) +
            "/" +
            parseInt(this.$route.query.feedbackId, 10)
        )
        .then(function (response) {
          if (response.data !== null) {
            _this.feedBackId=response.data.id;
            _this.type="online";
            _this.request.receivedInvitation = response.data.receivedInvitation;
            _this.request.satisfiedPreparation = response.data.satisfiedPreparation;
            _this.request.suitableTrainingRoom = response.data.suitableTrainingRoom;
            _this.request.expectedTrainingRoom = response.data.expectedTrainingRoom;
            _this.request.breakTimes = response.data.breakTimes;
            _this.request.cleanTrainingRoom = response.data.cleanTrainingRoom;
            _this.request.easyTrainingMaterial = response.data.easyTrainingMaterial;
            _this.request.theorypractice = response.data.theorypractice;
            _this.request.supportedlearningprocess =
              response.data.supportedlearningprocess;
            _this.request.learningspeed = response.data.learningspeed;
            _this.request.involvedtraining = response.data.involvedtraining;
            _this.request.newthings = response.data.newthings;
            _this.request.trainerwellprepared = response.data.trainerwellprepared;
            _this.request.trainerprofessional = response.data.trainerprofessional;
            _this.request.trainerexplained = response.data.trainerexplained;
            _this.request.trainerorganized = response.data.trainerorganized;
            _this.request.benefitseveryday = response.data.benefitseveryday;
            _this.request.recommendKnorr = response.data.recommendKnorr;
            _this.request.recommendtraining = response.data.recommendtraining;
          }
        });
    },
  },
};
</script>
